import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import ChildNewsfeedItem from "../child_newsfeed_item";

export default GrComponentFactory.createClass({
  displayName: "CommentNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.object.isRequired,
    update: React.PropTypes.object.isRequired,
  },

  headerText() {
    let resourceTypeDisplayName = this.props.update.resource.typeDisplayName;
    if (!resourceTypeDisplayName) {
      resourceTypeDisplayName = "update";
    }

    return `commented on an ${  resourceTypeDisplayName}`;
  },

  render(){
    return (
      <ChildNewsfeedItem update={this.props.update}
        user={this.props.resource.user}
        headerText={this.headerText()}/>
    );
  },

});
